import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
    accent1Color,
    alternateTextColor,
    appBarColor,
    flatButtonTextColor,
    floatingLabelColor,
    primary1Color,
    primary2Color,
    primary3Color,
    purple,
    white,
} from 'constants/colors';

export default getMuiTheme({
    appBar: {
        color: appBarColor,
        height: 47,
    },
    datePicker: {
        headerColor: purple,
        selectColor: purple,
        selectTextColor: white,
    },
    flatButton: { textColor: flatButtonTextColor },
    floatingActionButton: { color: primary1Color },
    fontFamily: 'effra',
    menuItem: { selectedTextColor: primary1Color },
    palette: {
        accent1Color,
        alternateTextColor,
        pickerHeaderColor: purple,
        primary1Color,
        primary2Color,
        primary3Color,
    },
    raisedButton: {
        color: primary1Color,
        fontSize: 14,
        secondaryColor: white,
        secondaryTextColor: primary1Color,
        textColor: alternateTextColor,
    },
    slider: {
        handleColorZero: primary1Color,
        handleFillColor: primary1Color,
        selectionColor: primary1Color,
        trackColor: '#d7d7d7',
    },
    textField: {
        borderColor: '#000000',
        floatingLabelColor,
    },
    timePicker: {
        accentColor: purple,
        headerColor: purple,
        selectTextColor: white,
    },
});



// WEBPACK FOOTER //
// ./src/theme.js